import React from 'react'
import styled from 'styled-components'
import {Box, Button as CoreButton} from '@miro-site/core'

const List = styled(Box).attrs(({theme}) => ({
  as: 'ul',
  $styles: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
}))``

List.displayName = 'CtaNavigation.List'

const ListItem = styled.li`
  ${props =>
    props.theme.normalizeStyles({
      marginRight: props.theme.header.ctaNavigation.gutter,
    })}

  &:last-child {
    margin-right: 0;
  }
`

ListItem.displayName = 'CtaNavigation.ListItem'

interface CtaNavigationProps {
  children: React.ReactNode
  needReferer?: boolean
}

const Button = styled(CoreButton)
  .withConfig({
    shouldForwardProp: prop => !['needReferer'].includes(prop),
  })
  .attrs<{$isMobileButton?: boolean; needReferer?: boolean}>(
    ({theme, $isMobileButton, needReferer = false}) => ({
      rel: needReferer ? 'strict-origin-when-cross-origin' : 'no-referrer',
      $buttonType: $isMobileButton
        ? theme.header.ctaNavigation.mobileButton.type
        : theme.header.ctaNavigation.button.type,
      $withArrow: true,
      $styles: $isMobileButton
        ? {
            ...theme.header.ctaNavigation.mobileButton.size,
            '.focus-trap': {
              ...theme.header.ctaNavigation.mobileButton.spacing,
            },
          }
        : {
            display: 'block',
            ...theme.header.ctaNavigation.button.size,
            '.focus-trap': {
              ...theme.header.ctaNavigation.button.spacing,
            },
          },
    }),
  )<{$isMobileButton?: boolean; needReferer?: boolean}>``

const CtaNavigation = (props: CtaNavigationProps): React.ReactElement => {
  return (
    <List>
      {React.Children.map(props.children, (c, i) => (
        <ListItem key={i}>{c}</ListItem>
      ))}
    </List>
  )
}

export default Object.assign(CtaNavigation, {Button: Button})
